import { handleFilesWithView } from "@/components/mailEditor/fileHandlers";
import EmailAttachment from "@/domain/entities/emails/EmailAttachement";
import { EditorView } from "@tiptap/pm/view";
import { Editor, useEditor } from "@tiptap/react";
import { Dispatch, SetStateAction } from "react";
import createEditorExtensions from "../components/mailEditor/config";

export interface UseSetMailEditorReturn {
    editor: Editor | null;
    suggestionEditor: Editor | null;
}

const handleFileDrop = (
    view: EditorView,
    event: Event,
    setAttachments?: Dispatch<SetStateAction<EmailAttachment[]>>,
): boolean => {
    if (view.hasFocus()) {
        // Filehandler from Tiptap does work only when editor is focused,
        // but it can manage position unlike handleFileDrop,
        // so we pass the event to handleFileDrop when the editor is focused
        return false;
    }

    const dragEvent = event as DragEvent;
    const files = dragEvent.dataTransfer?.files;

    if (!files || files.length === 0) {
        return false;
    }

    dragEvent.preventDefault();

    const pos = 1;
    handleFilesWithView(Array.from(files), view, pos, setAttachments);

    return true;
};

const useSetMailEditor = (
    setAttachments?: Dispatch<SetStateAction<EmailAttachment[]>>,
): UseSetMailEditorReturn => {
    const newEditor = (editable: boolean = true) =>
        useEditor({
            extensions: createEditorExtensions(setAttachments),
            editable,
            editorProps: {
                handleDOMEvents: {
                    dragenter: (_view, event) => {
                        // Allow drop by preventing the default behavior
                        event.preventDefault();

                        return false;
                    },
                    dragover: (_view, event) => {
                        // Allow drop by preventing the default behavior
                        event.preventDefault();

                        return false;
                    },
                    drop: (view, event) =>
                        handleFileDrop(view, event, setAttachments),
                },
            },
        });

    const editor = newEditor();

    const suggestionEditor = newEditor(false);

    return {
        editor,
        suggestionEditor,
    };
};

export default useSetMailEditor;
